// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FleetPerformanceOverviewAreaId } from './FleetPerformanceOverviewAreaId'
import {
  FleetPerformanceOverviewAreaNavigation,
  FleetPerformanceOverviewAreaNavigationIcon,
} from './FleetPerformanceOverviewAreaNavigation'
import { FleetPerformanceOverviewAreaRoutes } from './FleetPerformanceOverviewAreaRoutes'

const LazyFleetPerformanceOverviewComponent = lazy(
  () => import('./FleetPerformanceOverviewArea'),
)

const FleetPerformanceOverviewComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetPerformanceOverviewComponent />
  </SuspenseLoadingWrapper>
)

export const FleetPerformanceOverviewArea = {
  id: FleetPerformanceOverviewAreaId,
  requiredRight: BoumRight.AREA_FLEET_PERFORMANCE_OVERVIEW,
  Icon: FleetPerformanceOverviewAreaNavigationIcon,
  NavigationComponent: FleetPerformanceOverviewAreaNavigation,
  route: {
    path: FleetPerformanceOverviewAreaRoutes.route,
    component: FleetPerformanceOverviewComponent,
  },
}
